(function() { module.exports = window["Next"]["Dropdown"]; }());